import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {

  @Input() max = 100;
  @Input() min = 0;
  @Input() value = 50;
  @Input() name = 'slider';
  @Input() color = 'blue';
  @Input() unit = 'Years';
  @Input() step = 1;
  @Input() showValue;
  @Input() variableIncrement: boolean;
  @Input() disabled = false;

  sliderclasses = {};

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.sliderclasses['slider'] = true;
    this.showValue = true;
  }

  ngOnInit() {
    this.sliderclasses[this.color] = true;
    if (!this.showValue ) {
      this.sliderclasses['fullwidth'] = true;
    }
    console.log(this.showValue);
  }

  changeSliderValue($event) {
    this.value = $event.target.value;
    this.valueChange.emit(this.value);
  }
  updateValue(val) {
    if (this.variableIncrement) {
      if (val <= 10000) {
        this.step = 100;
      } else if (val <= 100000) {
        this.step = 1000;
      } else if (val <= 1000000) {
        this.step = 10000;
      }
    }
    this.value = parseInt(val);
    this.valueChange.emit(this.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/slider/slider.component.ts